module.exports = __webpack_public_path__ + "img/AquaKiss.15ba7b6e.jpeg";